import { IActionBase } from "../models/root.interface"
import { IDownloadsState } from "../models/downloads.interface"
import { EVENTS_DOWNLOAD } from "../actions/downloads.actions"

const initialState: IDownloadsState = {
    events: []
}

function downloadsReducer(
    state: IDownloadsState = initialState,
    action: IActionBase
): IDownloadsState {
    switch (action.type) {
        case EVENTS_DOWNLOAD: {
            return { ...state, events: action.events }
        }

        default:
            return state
    }
}

export default downloadsReducer
